<script lang="ts">
  interface Props {
    title: string;
    description?: string;
  }

  const { title, description }: Props = $props();
</script>

<!-- Title -->
<title>{title}</title>
<meta property="og:title" content={title} />

{#if description}
  <!-- Description-->
  <meta name="description" content={description} />
  <meta name="og:description" content={description} />
{/if}
